import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { KeyValue } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ClientListResolverService {

  constructor(private http: HttpClient) { }

  resolve(route: ActivatedRoute): Observable<KeyValue<number, string>[]> {
    return this.http.get<KeyValue<number, string>[]>(environment.baseUrl + 'weedfree/client/list');
  }
}
